import React from "react";
import { useNavContext } from "../context-api/nav-context";
import PageHeaderSmall from "./PageHeaderSmall";

const BlogImage = ({ img }) => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="section-wrapper global-blog_img"
      onMouseOver={closeNavbarMenu}
    >
      <div className="blog-image_wrapper">
        <img src={img} alt="" />
      </div>
    </section>
  );
};

export default BlogImage;
